module.exports = __webpack_public_path__ + "static/media/comment.ca721775.svg";